import Messages from "./messages.service";

const messagesModule = angular
  .module("app.services.messages", [])
  .service("Messages", Messages);

export default messagesModule;



// WEBPACK FOOTER //
// ./src/services/messages/messages.module.js